/* index.js */

"use strict";

const _ = require("lodash");

// const { labelByTypeData } = require("../CustomFieldsConstants");

module.exports = {
    checkboxFormatter,
    selectFormatter,
    // dataTypeFormatter,
    typeInfoFormatter,
    descriptionFormatter,
    defaultValueFormatter,
    deleteButtonFormatter,
    fieldFormatter,
    headingFormatter,
    ciAttributeFormatter,
    ciOrDeviceFormatter,
    directionFormatter,
    deviceTypeBaseFormatter,
    vendorFormatter,
    osFormatter,
    classNameFormatter,
    gwSiteAttributeFormatter,
    ciNetBoxAttributeFormatter,
    ciXDomeAttributeFormatter,
};

function checkboxFormatter(row, cell, value, columnDef, dataContext) {
    let checkbox = document.createElement("div");
    if (value) {
        checkbox = document.createElement("base-icon-gl");
        checkbox.dataset.icon = "common.check";
        checkbox.setDarkTheme(false);

        if (dataContext.isUnavailable) {
            checkbox.classList.add("disabled");
        }
    }
    return checkbox.outerHTML;
}

function selectFormatter(row, cell, value /*, columnDef, dataContext*/) {
    return value || "-";
}
// function dataTypeFormatter(row, cell, value, columnDef, dataContext) {
//     // return labelByTypeData(value, dataContext.typeInfo) || "";
// }

function descriptionFormatter(row, cell, value /*, columnDef, dataContext*/) {
    const description = document.createElement("div");
    description.setAttribute("title", value);
    description.classList.add("description");
    description.innerText = value || "";
    return description.outerHTML;
}

function headingFormatter(row, cell, value, columnDef, dataContext) {
    const heading = document.createElement("div");
    heading.setAttribute("title", value);
    heading.classList.add("column-title");
    heading.innerText = value || "";
    if (dataContext.isUnavailable) {
        heading.classList.add("disabled");
    }
    return heading.outerHTML;
}

function deleteButtonFormatter(row, cell, value, columnDef, dataContext) {
    const button = document.createElement("base-icon-gl");
    button.dataset.icon = "common.trash_bin";
    button.setDarkTheme(false);

    button.setAttribute("aria-label", `delete ${dataContext.name}`);
    button.setAttribute("role", "button");

    button.dataset.uuid = dataContext.id;
    if (dataContext.type === "xDome") {
        button.dataset.action = "delete-xd-sync-xd-to-gw";
    } else if (dataContext.type === "xDome_site") {
        button.dataset.action = "delete-xd-site-sync-xd-to-gw";
    } else if (dataContext.type === "netBox") {
        button.dataset.action =
            dataContext.syncDirection === "GW_TO_NB" ? "delete-nb-sync" : "delete-nb-sync-nb-to-gw";
    } else if (dataContext.type === "netBox_site") {
        button.dataset.action =
            dataContext.syncDirection === "GW_TO_NB"
                ? "delete-nb-site-sync"
                : "delete-nb-site-sync-nb-to-gw";
    } else if (_.get(dataContext, "syncDirection", false)) {
        button.dataset.action = "delete-sync";
    } else if (_.get(dataContext, "classes", false)) {
        button.dataset.action = "delete-mapping";
    } else {
        button.dataset.action = "delete";
    }

    return button.outerHTML;
}

const DATA_TYPES = {
    String: stringTypeFormatter,
    Number: numberTypeFormatter,
    Enum: enumTypeFormatter,
    Boolean: () => "",
};

function typeInfoFormatter(row, cell, value, columnDef, dataContext) {
    const dataType = dataContext.dataType || "";
    const typeInfoValue = value || "";

    const typeFormatter = DATA_TYPES[dataType];

    return typeFormatter
        ? `<div class="type-info type-${dataType}">${typeFormatter(typeInfoValue || {})}</div>`
        : "";
}

/**
 *
 * @param {Object}   enumTypeInfo
 * @param {string[]} [enumTypeInfo.ids]         - list of enum Ids
 * @param {string[]} [enumTypeInfo.labels]      - list of enum labels
 * @param {boolean}  [enumTypeInfo.multiSelect] - multi-select flag
 * @returns {string} - HTML markup string
 */
function enumTypeFormatter(enumTypeInfo) {
    const multiSelect = Boolean(enumTypeInfo.multiSelect);
    let labels = enumTypeInfo.labels || [];
    const valueSpan = document.createElement("span");

    labels = labels.join(", ");
    valueSpan.setAttribute("title", labels);
    valueSpan.innerText = labels;

    const hasInfo = labels.length;
    const info = [
        multiSelect && `<span class="boolean-state">Multiple</span>`,
        labels && `<span class="values-list" title="${labels}">${labels}</span>`,
    ]
        .filter(Boolean)
        .join("<br />");

    return hasInfo ? info : "";
}

/**
 *
 * @param {Object}  numberTypeInfo
 * @param {Object}  [numberTypeInfo.Number]             - number type info object
 * @param {number}  [numberTypeInfo.Number.max]         - max value for number type
 * @param {number}  [numberTypeInfo.Number.min]         - min value for number type
 * @param {boolean} [numberTypeInfo.Number.onlyInteger] - min value for number type
 * @returns {string} - HTML markup string
 */
function numberTypeFormatter(numberTypeInfo) {
    const data = numberTypeInfo.Number || {};
    const onlyInteger = Boolean(data.onlyInteger);

    const hasInfo = Number.isFinite(data.min) || Number.isFinite(data.max) || onlyInteger;
    const info = [
        onlyInteger &&
            `<span title="is Integer" class="boolean-state">${
                onlyInteger ? "Integers only" : ""
            }</span>`,
        Number.isFinite(data.min) && `<span title="${data.min}">min: ${data.min}</span>`,
        Number.isFinite(data.max) && `<span title="${data.min}">max: ${data.max}</span>`,
    ]
        .filter(Boolean)
        .join("<br />");
    return hasInfo ? info : "";
}

/**
 *
 * @param {Object} stringTypeInfo
 * @param {Object} [stringTypeInfo.String]         - string type info object
 * @param {string} [stringTypeInfo.String.pattern] - regexp validation pattern
 * @returns {string} - HTML markup string
 */
function stringTypeFormatter(stringTypeInfo) {
    const data = stringTypeInfo.String || {};
    const hasInfo = data.pattern;

    const info = `
        <div>Pattern: </div>
        <span title="${data.pattern}">${data.pattern}</span>
    `;
    return hasInfo ? info : "";
}

function defaultValueFormatter(row, cell, value /*, columnDef, dataContext*/) {
    const span = document.createElement("span");
    span.classList.add("default-value");
    span.setAttribute("title", value);
    span.innerText = value;

    return span.outerHTML;
}

function ciAttributeFormatter(row, cell, value, columnDef, dataContext) {
    const ddSelectObj =
        (dataContext["ciAttributesDropDownData"] || []).find((item) => item.value === value) || {};
    const ddLabel = ddSelectObj["label"] || "";
    const span = document.createElement("span");
    span.classList.add("default-value");
    span.innerText = ddLabel;

    return span.outerHTML;
}

function ciNetBoxAttributeFormatter(row, cell, value, columnDef, dataContext) {
    let ddSelectObj =
        (dataContext["ciAttributesDropDownData"] || []).find((item) => item.value === value) || {};

    if (_.isEmpty(ddSelectObj) && value.indexOf("other_field.") > -1) {
        ddSelectObj =
            (dataContext["ciAttributesDropDownData"] || []).find(
                (item) => item.value === "other"
            ) || {};
    }

    const ddLabel = ddSelectObj["label"] || "";

    const span = document.createElement("span");
    span.classList.add("default-value");

    if (_.isString(ddSelectObj.value) && ddSelectObj.value.indexOf("other") > -1) {
        span.innerText = "Other > " + dataContext["nbExtendedPropPath"];
    } else {
        span.innerText = ddLabel;
    }

    return span.outerHTML;
}

function gwSiteAttributeFormatter(row, cell, value, columnDef, dataContext) {
    const ddSelectObj =
        (dataContext["siteNodeDropDownData"] || []).find((item) => item.value === value) || {};
    const ddLabel = ddSelectObj["label"] || "";
    const span = document.createElement("span");
    span.classList.add("default-value");
    span.innerText = ddLabel;

    return span.outerHTML;
}

function fieldFormatter(row, cell, value, columnDef, dataContext) {
    const flattenedPath = _.isString(value) ? value : findPath(value, dataContext.solutions) || "";

    let field = flattenedPath;
    field = field.replace(/>/g, " > ");
    const span = document.createElement("span");
    span.classList.add("field-value");
    span.setAttribute("title", field);
    span.innerText = field;
    if (dataContext.isUnavailable) {
        span.classList.add("disabled");
    }

    return span.outerHTML;
}

function ciOrDeviceFormatter(row, cell, value, columnDef, dataContext) {
    const span = document.createElement("span");
    let fieldVal = "";

    if (columnDef.field === "sourceField") {
        if (dataContext.syncDirection === "DEVICE_TO_CI") {
            fieldVal =
                findPath(
                    dataContext.devicePropPath || dataContext.gwPropPath,
                    dataContext.solutions
                ) || "";
        } else if (dataContext.syncDirection === "CI_TO_DEVICE") {
            const ddSelectObj =
                (dataContext["ciAttributesDropDownData"] || []).find(
                    (item) => item.value === dataContext.cmdbAttr
                ) || {};
            fieldVal = ddSelectObj["label"] || "";
        }
    } else {
        if (dataContext.syncDirection === "DEVICE_TO_CI") {
            const ddSelectObj =
                (dataContext["ciAttributesDropDownData"] || []).find(
                    (item) => item.value === dataContext.cmdbAttr
                ) || {};
            fieldVal = ddSelectObj["label"] || "";
        } else if (dataContext.syncDirection === "CI_TO_DEVICE") {
            fieldVal =
                findPath(
                    dataContext.devicePropPath || dataContext.gwPropPath,
                    dataContext.solutions
                ) || "";
        }
    }

    span.innerText = fieldVal;
    return span.outerHTML;
}

function directionFormatter(row, cell, value) {
    const span = document.createElement("span");

    if (value === "CI_TO_DEVICE") {
        span.innerText = "CMDB";
    } else {
        span.innerText = "Gluware";
    }

    return span.outerHTML;
}

function deviceTypeBaseFormatter(row, cell, value, columnDef, dataContext) {
    const span = document.createElement("span");

    span.innerText = dataContext.deviceTypeData[value];

    return span.outerHTML;
}

function vendorFormatter(row, cell, value, columnDef, dataContext) {
    const span = document.createElement("span"),
        vendorVal = _.get(dataContext.vendorOsMap[value], "displayName", "Any");

    span.innerText = vendorVal;

    return span.outerHTML;
}

function osFormatter(row, cell, value, columnDef, dataContext) {
    const span = document.createElement("span"),
        vendorVal = dataContext.deviceVendor;
    let valuesOfOs = [];
    let osVal = "Any";
    if (vendorVal === "*") {
        valuesOfOs = extractUniqueOsValues(dataContext.vendorOsMap);
        osVal = valuesOfOs[value] || "Any";
    } else {
        const vendorObj = dataContext.vendorOsMap[vendorVal],
            allValsSelected = extractUniqueOsValues({[vendorVal]: vendorObj});

        if (allValsSelected[value]) {
            osVal = allValsSelected[value];
        } else {
            osVal = "Any";
        }
    }

    span.innerText = osVal;

    return span.outerHTML;
}

function classNameFormatter(row, cell, value, columnDef, dataContext) {
    const span = document.createElement("span");
    let pathStr = "";

    try {
        const path = findClassPath(value, dataContext.classes);

        if (path && path.length > 0) {
            pathStr = path.reverse().join(" > ");
        }
    } catch (error) {
        console.error("Error while formatting class name:", error);
    }

    span.innerText = pathStr;

    return span.outerHTML;
}

function extractUniqueOsValues(data) {
    const osValueObj = {};

    for (const key of Object.keys(data)) {
        if (data[key].os) {
            for (const osName of Object.keys(data[key].os)) {
                osValueObj[osName] = data[key].os[osName].displayName;
            }
        }
    }

    return osValueObj;
}

function findPath(input, obj, currentPath = []) {
    for (const key in obj) {
        if (key === "path" && obj[key].join(".") === input.join(".")) {
            return currentPath.join(" > ");
        } else if (typeof obj[key] === "object") {
            const result = findPath(input, obj[key], [...currentPath, key]);
            if (result) {
                return result;
            }
        }
    }
    return null; // If not found, return null
}

function findClassPath(input, classObj, path = []) {
    if (!classObj) {
        return null;
    }

    const valObj = classObj[input];

    if (!valObj) {
        return null;
    }

    path.push(valObj.displayName);
    if (valObj.parent) {
        return findClassPath(valObj.parent, classObj, path);
    }
    return path;
}

function ciXDomeAttributeFormatter(row, cell, value, columnDef, dataContext) {
    let ddSelectObj =
        (dataContext["ciAttributesDropDownData"] || []).find((item) => item.value === value) || {};

    if (_.isEmpty(ddSelectObj) && value.indexOf("other_field.") > -1) {
        ddSelectObj =
            (dataContext["ciAttributesDropDownData"] || []).find(
                (item) => item.value === "other"
            ) || {};
    }

    const ddLabel = ddSelectObj["label"] || "";

    const span = document.createElement("span");
    span.classList.add("default-value");

    if (_.isString(ddSelectObj.value) && ddSelectObj.value.indexOf("other") > -1) {
        span.innerText = "Other > " + dataContext["xdExtendedPropPath"];
    } else {
        span.innerText = ddLabel;
    }

    return span.outerHTML;
}
